import styled from "styled-components";

export const AssistantPlaceholderWrapper = styled.div`
  height: ${(props) => props.$height}px;
  width: ${(props) => props.$mobileWidth};
  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    width: ${(props) => props.$tabletWidth};
  }
  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    width: ${(props) => props.$desktopWidth};
  }
`;
